import React from 'react';
import s from './PaginationWidget.scss';

const getPageNumbers = (totalStories, storiesPerPage, currentPage) => {
  // Calculate the total number of pages
  const totalPages = Math.ceil(totalStories / storiesPerPage);

  if (currentPage > totalPages) {
    return [];
  }

  // Determine the starting page number for the array of 5 page numbers
  let startPage = currentPage;
  const endPage = Math.min(totalPages, startPage + 4);

  // Adjust the starting page number if there are not enough pages to display
  if (endPage - startPage < 4) {
    startPage = Math.max(1, endPage - 4);
  }

  // Store the 5 page numbers in an array
  // const pageNumbers = [];
  // for (let i = startPage; i <= endPage; i += 1) {
  //   pageNumbers.push(i);
  // }
  const pageNumbers = Array.from(
    { length: Math.min(5, totalPages) },
    (_, index) => startPage + index,
  );

  return pageNumbers;
};

const PaginationWidgetWithoutLink = props => {
  const {
    currentPage = 1,
    totalStories,
    storiesPerPage,
    isMobile,
    onPageChange,
  } = props;

  const totalPages = Math.ceil(totalStories / storiesPerPage);
  const pages = getPageNumbers(totalStories, storiesPerPage, currentPage);

  if (!(Array.isArray(pages) && pages.length && pages.length > 0)) {
    return null;
  }

  return (
    <div className={`${isMobile ? s.mobileWrapper : ''} ${s.paginationWrap}`}>
      <span
        className={`${s.arrowBtn}  ${!(currentPage > 1) ? s.disabled : ''} ${
          s.prevButton
        }`}
        onClick={() => {
          onPageChange(currentPage - 1);
        }}
      />

      <ul>
        {pages.map(page => (
          <li>
            <span
              className={page === currentPage ? s.selected : ''}
              onClick={() => {
                onPageChange(page);
              }}
            >
              {page}
            </span>
          </li>
        ))}
      </ul>

      <span
        className={`${s.arrowBtn} ${s.nextButton} ${
          !(currentPage + 1 <= totalPages) ? s.disabled : ''
        }`}
        onClick={() => {
          onPageChange(currentPage + 1);
        }}
      />
    </div>
  );
};

export default PaginationWidgetWithoutLink;
